// Keeping the reader's place while posts are added above (the timeline's
// "Show new"). Browsers with scroll anchoring mostly do this themselves;
// then the correction here is zero. Safari has none.

// the post being read: the first one whose bottom is below the given line
// (the bottom of a sticky header)
export const readingAnchor = (elements, top = 0) =>
  [...(elements ?? [])].find((el) => el.getBoundingClientRect().bottom > top) ??
  null

// runs change (async: resolves once the DOM has updated) and scrolls so that
// anchor stays where it was on the screen. false: the anchor is no longer
// in the page (the change dropped it), nothing was scrolled.
export const keepInView = async (anchor, change) => {
  if (!anchor) {
    await change()
    return false
  }
  const before = anchor.getBoundingClientRect().top
  const correct = () => {
    if (!anchor.isConnected) return false
    const shift = anchor.getBoundingClientRect().top - before
    if (Math.abs(shift) >= 1) window.scrollBy(0, shift)
    return true
  }
  await change()
  if (!correct()) return false
  // once more after the next frame: the new posts settle their height
  await new Promise((resolve) => requestAnimationFrame(resolve))
  return correct()
}
